import { Component, Input, OnInit } from '@angular/core';
import Product from '../../../../model/product/product';
import { Project } from 'src/app/model/project/project';
import { SubProject } from '../../../../model/project/sub-project';

@Component({
  selector: 'product-summary-picker',
  templateUrl: './product-summary-picker.component.html',
  styleUrls: ['./product-summary-picker.component.scss']
})
export class ProductSummaryPickerComponent implements OnInit {
  @Input()
  index = 0;

  @Input()
  inputProduct: Product;

  @Input()
  inputSubProject: SubProject;
  @Input()
  inputProject: Project;

  @Input()
  productPrice: string;

  @Input()
  client = false;

  constructor() {}

  ngOnInit() {}
}
